import React, { useState, useEffect } from "react";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import HeaderComponent from "../../website/HeaderComponent";
// import "../AllStudents/allStudents.scss";
import { Link } from "react-router-dom";
import { dummyStudentData, imageLink } from "../../../actions/utility";
import { Collapse, Button, CardBody, Card } from "reactstrap";
import { getAllStudents, getReferralStudents } from "../../../actions/emActions";
import emptyImage from "../../../public/images/empty.svg";
import moment from "moment";

const ReferralStudents = (props) => {
  const [studentsData, setstudentsData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setuserName] = useState("");
  const [email, setemail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");

  const toggle = () => setIsOpen(!isOpen);

  const getData = () => {
    getReferralStudents().then((res) => {
      setstudentsData(res.data);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getData();
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [userName, email, phoneNumber]);

  return (
    <div className="AllStudensComponent">
      <HeaderComponent />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <RightSectionEM />
            </div>

            <div className="col-md-9">
              <h5>Referral Students:</h5>
              <hr />

              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Program Name</th>
                    <th scope="col">Contact Info</th>
                    <th scope="col">Joining date</th>
                    <th scope="col">Referred by</th>
                  </tr>
                </thead>
                <tbody>
                  {studentsData &&
                    studentsData.map((item, index) => (
                      <tr>
                        <th scope="row">{index + 1}.</th>
                        <td>
                          {/* <Link to={`/dashboards/StudentDetails/${item.id}`}> */}
                          <div className="studentimgName">
                            <img
                              className="studentImgAvatar"
                              src={
                                item?.referent_nu_users !== null &&
                                item?.referent_nu_users?.image !== null
                                  ? imageLink(item?.referent_nu_users?.image)
                                  : emptyImage
                              }
                            />
                            <label className="">{item?.referent_nu_users?.user_name}</label>
                          </div>
                          {/* </Link> */}
                        </td>
                        <td>
                          <label>{item?.lm_course?.course_name}</label>
                        </td>
                        <td>
                          <div>
                            <label className="mb-0 generalText">
                              <i className="fa fa-envelope mr-2 iconColor"></i>
                              {item?.referent_nu_users?.user_email}
                            </label>
                            <br />
                            <label className="mb-0 generalText">
                              <i className="fa fa-phone mr-2 iconColor"></i> +
                              {item?.referent_nu_users?.lm_candidate_profile[0].phone}
                            </label>
                          </div>
                        </td>

                        <td>{moment(item.ts).format("Do MMM 'YY")}</td>
                        <td>
                          <Link to={`/dashboards/StudentDetails/${item?.referral_nu_users?.id}`}>
                            <div className="studentimgName">
                              <img
                                className="studentImgAvatar"
                                src={
                                  item?.referral_nu_users?.image !== null
                                    ? imageLink(item?.referral_nu_users?.image)
                                    : emptyImage
                                }
                              />
                              <label className="">{item?.referral_nu_users?.user_name}</label>
                            </div>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralStudents;
